/* ==========================================================================
   Elevate Floors — Seção 02: cabeçalho e menu
   --------------------------------------------------------------------------
   O abrir/fechar do dropdown é CSS puro (:hover / :focus-within). Este arquivo
   cuida só do que CSS não faz:
     (8)(9) sombra do cabeçalho + véu, apenas para itens COM submenu
     (10a)  troca da imagem no mega "banner"
     (11)   drawer mobile e accordions

   Escrito com nomes próprios em vez de reusar setupNavToggle do tema: aquele
   liga UMA vez em theme.js:1150 e não religa em shopify:section:load, então o
   hambúrguer morre depois de cada save no editor de tema até dar F5.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var header = document.getElementById('ef-header');
    if (!header) return;

    var scrim = document.querySelector('.ef-scrim');

    /* (8)(9) sombra e véu apenas para itens COM submenu ------------------- */
    header.querySelectorAll('.ef-nav__item.has-sub').forEach(function (item) {
      var on = function () {
        header.classList.add('has-open');
        if (scrim) scrim.classList.add('is-on');
      };
      var off = function () {
        header.classList.remove('has-open');
        if (scrim) scrim.classList.remove('is-on');
      };
      item.addEventListener('mouseenter', on);
      item.addEventListener('mouseleave', off);
      item.addEventListener('focusin', on);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) off();
      });
    });

    /* (10a) troca da imagem no mega banner -------------------------------- */
    header.querySelectorAll('.ef-panel--banner').forEach(function (panel) {
      var rows = panel.querySelectorAll('.ef-mega__row');
      var shots = panel.querySelectorAll('.ef-mega__shot');
      var caption = panel.querySelector('[data-caption]');

      rows.forEach(function (row) {
        var show = function () {
          var key = row.dataset.key;
          rows.forEach(function (r) { r.classList.toggle('is-active', r === row); });
          shots.forEach(function (s) { s.classList.toggle('is-active', s.dataset.key === key); });
          if (caption) caption.textContent = (row.dataset.title || row.textContent).trim();
        };
        row.addEventListener('mouseenter', show);
        row.addEventListener('focus', show);
      });
    });

    /* (11) drawer mobile ---------------------------------------------------
       É uma folha que SOBE, não um drawer lateral. O overlay é irmão do drawer
       e some junto. Três caminhos de saída: a alça, o overlay e o clique em
       qualquer link — todos marcados com data-drawer-close no markup. */
    var drawer = document.getElementById('ef-drawer');
    var burger = header.querySelector('.ef-burger');
    if (!drawer || !burger) return;

    var overlay = document.querySelector('.ef-drawer-overlay');

    function openDrawer() {
      drawer.hidden = false;
      // o rAF existe porque o elemento sai de display:none: sem um frame no
      // estado fechado, o navegador não tem de onde animar
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-on');
      });
      document.documentElement.classList.add('open-drawer');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      if (drawer.hidden) return;
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-on');
      document.documentElement.classList.remove('open-drawer');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      // 450ms = a duração da transição da folha; antes disso ela sumiria seca
      setTimeout(function () { drawer.hidden = true; }, 450);
    }

    burger.addEventListener('click', openDrawer);

    document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      if (el._efCloseBound) return;
      el._efCloseBound = true;
      el.addEventListener('click', closeDrawer);
    });

    if (!document._efEsc) {
      document._efEsc = true;
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var d = document.getElementById('ef-drawer');
        if (!d || d.hidden) return;
        d.classList.remove('is-open');
        var ov = document.querySelector('.ef-drawer-overlay');
        if (ov) ov.classList.remove('is-on');
        document.documentElement.classList.remove('open-drawer');
        d.setAttribute('aria-hidden', 'true');
        var b = document.querySelector('.ef-burger');
        if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
        setTimeout(function () { d.hidden = true; }, 450);
      });
    }

    /* UM SUBMENU POR VEZ, ao contrário da FAQ, onde abrem independentes. Aqui é
       navegação: dois submenus abertos empurram os outros itens para fora da
       tela. */
    var accs = drawer.querySelectorAll('.ef-acc');
    accs.forEach(function (acc) {
      var btn = acc.querySelector('.ef-acc__head');
      if (!btn || btn._efAccBound) return;
      btn._efAccBound = true;

      btn.addEventListener('click', function () {
        var willOpen = !acc.classList.contains('is-open');
        accs.forEach(function (other) {
          other.classList.remove('is-open');
          var b = other.querySelector('.ef-acc__head');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          acc.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
